<template>
  <v-reports
    v-if="access.report_sale"
    v-model="page"
    v-bind:headers="headers"
    v-bind:update="update"
    v-bind:data="data"
    v-bind:numPages="numPages"
    :data_loading="data_loading"
    :chart_loading="chart_loading"
    @change-pagination="changePagination"
    ref="main"
    summary
  >
    <template #header>
      <v-tabs fixed-tabs icons-and-text centered v-model="target">
        <v-tab>
          <v-list-item three-line class="py-2 mx-0 px-0">
            <v-list-item-content>
              <v-list-item-subtitle
                >{{ $t(`gross_sales`) }}
              </v-list-item-subtitle>
              <v-list-item-title
                >{{
                  (
                    Math.round(chart_specs.gross_sales * current_currency) /
                    current_currency
                  ).toLocaleString()
                }}
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-tab>
        <v-tab>
          <v-list-item three-line class="py-2 mx-0 px-0">
            <v-list-item-content>
              <v-list-item-subtitle>{{ $t(`refunds`) }}</v-list-item-subtitle>
              <v-list-item-title
                >{{
                  (
                    Math.round(chart_specs.refunds * current_currency) /
                    current_currency
                  ).toLocaleString()
                }}
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-tab>
        <v-tab>
          <v-list-item three-line class="py-2 mx-0 px-0">
            <v-list-item-content>
              <v-list-item-subtitle>{{ $t(`discounts`) }}</v-list-item-subtitle>
              <v-list-item-title
                >{{
                  (
                    Math.round(chart_specs.discounts * current_currency) /
                    current_currency
                  ).toLocaleString()
                }}
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-tab>
        <v-tab>
          <v-list-item three-line class="py-2 mx-0 px-0">
            <v-list-item-content>
              <v-list-item-subtitle>{{ $t(`debt`) }}</v-list-item-subtitle>
              <v-list-item-title
                >{{
                  (
                    Math.round(chart_specs.debt * current_currency) /
                    current_currency
                  ).toLocaleString()
                }}
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-tab>
        <v-tab>
          <v-list-item three-line class="py-2 mx-0 px-0">
            <v-list-item-content>
              <v-list-item-subtitle
                >{{ $t(`cash_backs`) }}
              </v-list-item-subtitle>
              <v-list-item-title>
                <div v-if="chart_specs.cash_back">
                  {{
                    (
                      Math.round(chart_specs.cash_back * current_currency) /
                      current_currency
                    ).toLocaleString()
                  }}
                </div>
                <div v-else>0</div>
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-tab>
        <v-tab>
          <v-list-item three-line class="py-2 mx-0 px-0">
            <v-list-item-content>
              <v-list-item-subtitle>{{ $t(`net_sales`) }}</v-list-item-subtitle>
              <v-list-item-title
                >{{
                  (
                    Math.round(chart_specs.net_sales * current_currency) /
                    current_currency
                  ).toLocaleString()
                }}
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-tab>
        <v-tab>
          <v-list-item three-line class="py-2 mx-0 px-0">
            <v-list-item-content>
              <v-list-item-subtitle
                >{{ $t(`gross_profit`) }}
              </v-list-item-subtitle>
              <v-list-item-title
                >{{
                  (
                    Math.round(chart_specs.gross_profit * current_currency) /
                    current_currency
                  ).toLocaleString()
                }}
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-tab>
      </v-tabs>
      <!-- <v-card-text> -->
      <v-layout row px-10>
        <v-flex md3 xs12 class="mt-2">
          <p class="pt-6">{{ target_names[target] }}</p>
        </v-flex>
        <v-spacer />
        <v-flex md3 xs6 class="px-1 mt-2 body-2">
          <v-select
            v-model="type_chart"
            :items="[
              { text: 'Диаграмма с областями', value: 1 },
              { text: 'Столбчатая диаграмма', value: 2 },
            ]"
            item-text="text"
          />
        </v-flex>
        <v-flex md2 xs6 class="px-2 mt-2 caption">
          <v-select
            v-model="count_chart"
            :items="count_items"
            item-text="text"
            @change="countChanged"
          ></v-select>
        </v-flex>
      </v-layout>
      <GChart
        v-if="type_chart == 1"
        v-bind:data="chart_data"
        v-bind:options="chart_options"
        v-bind:settings="{ packages: ['corechart'] }"
        v-bind:createChart="
          (el, google) => new google.visualization.AreaChart(el)
        "
      />
      <GChart
        v-else
        type="ColumnChart"
        v-bind:data="chart_data"
        v-bind:options="chart_option"
      />
    </template>
    <template #search_text>
      <v-btn icon @click="downloadExcel">
        <v-icon>mdi-download</v-icon>
      </v-btn>
      <v-dialog v-model="proccesDialog" max-width="400px">
        <v-card>
          <v-list-item-action style="width: 338px; padding-left: 40px">
            <v-progress-linear
              :color="excel_dowload_proccess ? 'primary' : 'rgba(0,0,0,0.26)'"
              background-color="white"
              height="10"
              style="border: 1px solid rgba(0, 0, 0, 0.26)"
              v-bind:value="excel_dowload_proccess"
              striped
            />
            <v-list-item-action-text
              >{{ $t("download") }}
              {{ excel_dowload_proccess.toFixed() + " %" }}
            </v-list-item-action-text>
          </v-list-item-action>
        </v-card>
      </v-dialog>
    </template>
  </v-reports>
  <error404 v-else></error404>
</template>
<script>
import Currency from "../../mixins/settings/currency";
import fileSaver from "file-saver";
import xlsx from "xlsx";
export default {
  name: "ReportsSummary",
  mixins: [Currency],
  data: () => ({
    type_chart: 1,
    count_chart: 2,
    count_items: [
      { text: "Hours", value: 1, disabled: true },
      { text: "Days", value: 2 },
      { text: "Weeks", value: 3 },
      { text: "Months", value: 4 },
      { text: "Quarters", value: 5 },
      { text: "Years", value: 6 },
    ],
    target: 0,
    chart_loading: false,
    data_loading: false,
    targets: [
      "gross_sales",
      "refunds",
      "discounts",
      "debt",
      "net_sales",
      "gross_profit",
      "cash_back",
    ],
    target_names: [],
    count: 24,
    chart_specs: {
      gross_sales: 0,
      refunds: 0,
      debt: 0,
      discounts: 0,
      net_sales: 0,
      gross_profit: 0,
      cash_back: 0,
    },
    chart_data: [
      ["Time", "Gross sales"],
      [0, 0],
    ],
    chart_options: {
      legend: {
        position: "top",
      },
      height: 415,
      chartArea: { width: "90%", left: "8%" },
      theme: "material",
      textStyle: {
        color: "#871b47",
        auraColor: "#d799ae",
        opacity: 0.8,
      },
      colors: ["#3e6187"],
    },
    chart_option: {
      legend: {
        position: "top",
      },
      height: 415,
      chartArea: { width: "90%", left: "8%" },
      theme: "material",
      textStyle: {
        color: "#871b47",
        auraColor: "#d799ae",
        opacity: 0.8,
      },
      colors: ["#3e6187"],
    },
    headers: [],
    data: [],
    page: 1,
    numPages: 1,
    params: {},
    current_currency: 1,
    downExcel: [],
    excel_name: "Report",
    wait: true,
    dialog: false,
    proccesDialog: false,
    excel_dowload_proccess: 0,
    max_total: 0,
  }),
  methods: {
    countChanged() {
      this.update(this.params);
    },
    checkCount() {
      var start = new Date(this.params.start_date).getTime();
      var end = new Date(this.params.end_date).getTime();
      if (start + 86400000 >= end) {
        this.count_items = [
          { text: "Hours", value: 1 },
          { text: "Days", value: 2, disabled: true },
          { text: "Weeks", value: 3, disabled: true },
          { text: "Months", value: 4, disabled: true },
          { text: "Quarters", value: 5, disabled: true },
          { text: "Years", value: 6, disabled: true },
        ];
        this.count_chart = 1;
      } else {
        this.count_items = [
          { text: "Hours", value: 1, disabled: true },
          { text: "Days", value: 2 },
          {
            text: "Weeks",
            value: 3,
            disabled: (end - start) / (24 * 60 * 60 * 1000) < 7,
          },
          {
            text: "Months",
            value: 4,
            disabled: (end - start) / (24 * 60 * 60 * 1000) < 30,
          },
          {
            text: "Quarters",
            value: 5,
            disabled: (end - start) / (24 * 60 * 60 * 1000) < 4 * 30,
          },
          {
            text: "Years",
            value: 6,
            disabled: (end - start) / (24 * 60 * 60 * 1000) < 12 * 30,
          },
        ];
        this.count_chart = this.count_chart == 1 ? 2 : this.count_chart;
      }
    },
    changeLang() {
      this.$i18n.locale = "uz";
    },
    changePagination(page) {
      this.page = page;
      this.update(this.params);
    },
    async update(params) {
      this.params = params;
      this.checkCount();
      const start_date = new Date(params.start_date);
      const end_date = new Date(params.end_date);
      this.data_loading = true;
      this.chart_loading = true;
      const current_currency = this.current_currency;
      const charts = this.$communicator.then(
        this,
        await this.$communicator("summary_chart", {
          arguments: [start_date.getTime(), end_date.getTime()],
          params: {
            target: this.targets[this.target],
            count_type: this.count_chart,
            custom: params.custom,
            start: params.start.time,
            end: params.end.time,
            services: params.service != "" ? [params.service] : [],
            employees: params.employee._id != "" ? [params.employee._id] : [],
            count: this.count,
          },
        })
      );
      this.chart_loading = false;
      if (charts) {
        var chart_data = [["Time", this.target_names[this.target]]];
        // Umar
        if (this.count_chart == 1) {
          for (const index in charts.data) {
            if (index < 19)
              chart_data.push([
                this.date_hhmm(charts.data[index][0]),
                charts.data[index][1],
              ]);
          }
          for (const index in charts.data) {
            if (index >= 19)
              chart_data.push([
                this.date_hhmm(charts.data[index][0]),
                charts.data[index][1],
              ]);
          }
        } else {
          for (const index in charts.data) {
            chart_data.push([
              this.date_ddmmyy(charts.data[index][0], 5 * 60 * 60 * 1000),
              charts.data[index][1],
            ]);
          }
        }
        this.chart_data = chart_data;
        this.chart_specs = {
          gross_sales: charts.gross_sales,
          refunds: charts.refunds,
          debt: charts.debt,
          cash_back: charts.cash_back,
          discounts: charts.discounts,
          net_sales: charts.net_sales,
          gross_profit: charts.gross_profit,
        };
      }
      const reports = this.$communicator.then(
        this,
        await this.$communicator("summary", {
          arguments: [start_date.getTime(), end_date.getTime(), 10, this.page],
          params: {
            custom: params.custom,
            count_type:
              params.custom && start_date.getTime() === end_date.getTime()
                ? 1
                : this.count_chart == 1
                ? 2
                : this.count_chart,
            start: params.start.time,
            end: params.end.time,
            services: params.service != "" ? [params.service] : [],
            employees: params.employee._id != "" ? [params.employee._id] : [],
          },
        })
      );
      this.max_total = reports.total;
      if (reports) {
        for (let i = 0; i < reports.data?.length; i++) {
          const time = reports.data[i].date;
          reports.data[i].gross_sales =
            Math.round(reports.data[i].gross_sales * current_currency) /
            current_currency;
          reports.data[i].refunds = (
            Math.round(reports.data[i].refunds * current_currency) /
            current_currency
          ).toLocaleString();
          reports.data[i].discounts = (
            Math.round(reports.data[i].discounts * current_currency) /
            current_currency
          ).toLocaleString();
          reports.data[i].debt = (
            Math.round(reports.data[i].debt * current_currency) /
            current_currency
          ).toLocaleString();
          reports.data[i].net_sales = (
            Math.round(reports.data[i].net_sales * current_currency) /
            current_currency
          ).toLocaleString();
          reports.data[i].cost_of_goods = (
            Math.round(reports.data[i].cost_of_goods * current_currency) /
            current_currency
          ).toLocaleString();
          reports.data[i].gross_profit = (
            Math.round(reports.data[i].gross_profit * current_currency) /
            current_currency
          ).toLocaleString();
          reports.data[i].cash_backs = (
            Math.round(reports.data[i].cash_back * current_currency) /
            current_currency
          ).toLocaleString();
          reports.data[i].taxes = (
            Math.round(reports.data[i].taxes * current_currency) /
            current_currency
          ).toLocaleString();
          reports.data[i].recepts_count =
            Math.round(reports.data[i].recepts_count * current_currency) /
            current_currency;
          reports.data[i].time = this.date_ddmmyy(time);
        }
        this.data = reports.data;
        this.data_loading = false;
        this.numPages = reports.page;
      }
    },
    async downloadExcel() {
      this.proccesDialog = true;
      this.excel_dowload_proccess = 0;
      this.loading = true;
      const limit = 500;
      let all_data = [];
      const start_date = new Date(this.params.start_date);
      const end_date = new Date(this.params.end_date);
      const current_currency = this.current_currency;
      const page_count = Math.ceil(this.max_total / limit);
      for (let page = 1; page <= page_count; page++) {
        const reports = this.$communicator.then(
          this,
          await this.$communicator("summary", {
            arguments: [start_date.getTime(), end_date.getTime(), 10000, 1],
            params: {
              custom: this.params.custom,
              count_type:
                this.params.custom &&
                start_date.getTime() === end_date.getTime()
                  ? 1
                  : this.count_chart == 1
                  ? 2
                  : this.count_chart,
              start: this.params.start.time,
              end: this.params.end.time,
              services: this.params.service != "" ? [this.params.service] : [],
              employees:
                this.params.employee._id != ""
                  ? [this.params.employee._id]
                  : [],
            },
          })
        );
        this.excel_dowload_proccess = (page / page_count) * 100;
        all_data.push(...reports?.data);
      }
      this.proccesDialog = false;
      const result = await all_data.map((rep) => ({
        date: this.date_ddmmyy(rep.date),
        gross_sales: (
          Math.round(rep.gross_sales * current_currency) / current_currency
        ).toLocaleString(),
        gross_profit: (
          Math.round(rep.gross_profit * current_currency) / current_currency
        ).toLocaleString(),
        cost_of_goods: (
          Math.round(rep.cost_of_goods * current_currency) / current_currency
        ).toLocaleString(),
        refunds: (
          Math.round(rep.refunds * current_currency) / current_currency
        ).toLocaleString(),
        net_sales: (
          Math.round(rep.net_sales * current_currency) / current_currency
        ).toLocaleString(),
        discounts: (
          Math.round(rep.discounts * current_currency) / current_currency
        ).toLocaleString(),
        reciepts_count: (
          Math.round(rep.recepts_count * current_currency) / current_currency
        ).toLocaleString(),
        average_reciept: (
          Math.round((rep.gross_sales / rep.recepts_count) * current_currency) /
          current_currency
        ).toLocaleString(),
      }));
      const ws = xlsx.utils.json_to_sheet(result);
      const wb = { Sheets: { data: ws }, SheetNames: ["data"] };
      const excelBuffer = xlsx.write(wb, { bookType: "xlsx", type: "array" });
      const excel_data = new Blob([excelBuffer], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8",
      });
      fileSaver.saveAs(excel_data, "Summary.xlsx");
    },
  },
  mounted() {
    this.get_currency();
    this.current_currency = this.currentCurrency == "usd" ? 100 : 1;
    this.headers = [
      { text: this.$t(`date`), value: "time", available: true },
      { text: this.$t(`gross_sales`), value: "gross_sales", available: true },
      { text: this.$t(`refunds`), value: "refunds", available: true },
      { text: this.$t(`discounts`), value: "discounts", available: true },
      { text: this.$t(`debt`), value: "debt", available: true },
      { text: this.$t(`net_sales`), value: "net_sales", available: true },
      {
        text: this.$t(`cost_of_goods`),
        value: "cost_of_goods",
        available: true,
      },
      { text: this.$t(`gross_profit`), value: "gross_profit", available: true },
      {
        text: this.$t(`reciepts_count`),
        value: "recepts_count",
        available: true,
      },
      {
        text: this.$t(`average_reciept`),
        value: "average_reciept",
        available: true,
      },
      // {text: 'Margin', value: 'margin', available: false},
      // { text: this.$t(`taxes`), value: "tax", available: false }
    ];
    for (const index in this.headers) {
      this.headers[index]["sortable"] = false;
    }
    this.target_names = [
      this.$t(`gross_sales`),
      this.$t(`refunds`),
      this.$t(`discounts`),
      this.$t(`debt`),
      this.$t(`cash_backs`),
      this.$t(`net_sales`),
      this.$t(`gross_profit`),
    ];
  },
  beforeMount() {
    this.access = this.$store.state.access;
  },
  watch: {
    target() {
      this.$refs["main"].update_reports();
    },
    currentCurrency() {
      this.current_currency = this.currentCurrency == "usd" ? 100 : 1;
    },
  },
};
</script>
